import { textareaField } from '../../../utils/field-config-helpers';

export const pharmacyRecordsFieldsConfig = {
  previousDentalRecords: textareaField(),
  shareDentalRecords: textareaField(),
  patientArticles: textareaField(),
  sharePatientPrescription: textareaField(),
};

export type PharmacyRecordsFieldsConfigTypes = typeof pharmacyRecordsFieldsConfig;
